module.exports = __webpack_public_path__ + "img/screenshot-3.15fea502.png";